/* Product page: hover preview thumbnails + border on selected thumbnail */
(function () {
  const selectedBySection = {};

  function getVisibleThumbnails(thumbnailWrapper) {
    return Array.from(thumbnailWrapper.querySelectorAll(".x-thumbnail")).filter(function (thumb) {
      return thumb.offsetParent !== null;
    });
  }

  function getRealSlides(mediaList) {
    return Array.from(mediaList.querySelectorAll(".x-splide-slide, .splide__slide")).filter(function (slide) {
      return !slide.classList.contains("splide__slide--clone");
    });
  }

  function getSectionData(thumbnail) {
    const thumbnailWrapper = thumbnail.closest('[id^="x-product-thumbnail-"]');
    if (!thumbnailWrapper) return null;

    const sectionId = thumbnailWrapper.id.replace("x-product-thumbnail-", "");
    const mainSlider = document.getElementById("x-product-" + sectionId);
    const mediaList = document.getElementById("media_product-" + sectionId);

    if (!mainSlider || !mainSlider.splide || !mediaList) return null;

    return {
      sectionId,
      thumbnailWrapper,
      mainSlider,
      mediaList,
      thumbnails: getVisibleThumbnails(thumbnailWrapper),
      realSlides: getRealSlides(mediaList)
    };
  }

  function getMediaIdFromThumbnail(thumbnail) {
    return thumbnail.getAttribute("data-media-id");
  }

  function getIndexFromMediaId(data, mediaId) {
    return data.realSlides.findIndex(function (slide) {
      return slide.getAttribute("data-media-id") === mediaId;
    });
  }

  function setActiveThumbnailByMediaId(thumbnailWrapper, mediaId) {
    getVisibleThumbnails(thumbnailWrapper).forEach(function (thumb) {
      thumb.classList.toggle(
        "custom-active-thumbnail",
        thumb.getAttribute("data-media-id") === mediaId
      );
    });
  }

  function getCurrentMediaId(data) {
    const currentIndex = data.mainSlider.splide.index || 0;
    const currentSlide = data.realSlides[currentIndex];

    if (currentSlide) {
      return currentSlide.getAttribute("data-media-id");
    }

    const activeSlide = data.mediaList.querySelector(
      ".splide__slide.is-active:not(.splide__slide--clone), .x-splide-slide.is-active:not(.splide__slide--clone)"
    );

    return activeSlide ? activeSlide.getAttribute("data-media-id") : null;
  }

  function goToMediaId(data, mediaId) {
    const targetIndex = getIndexFromMediaId(data, mediaId);

    if (targetIndex >= 0) {
      data.mainSlider.splide.go(targetIndex);
    }
  }

  function initSelectedStates() {
    document.querySelectorAll('[id^="x-product-thumbnail-"]').forEach(function (thumbnailWrapper) {
      const sectionId = thumbnailWrapper.id.replace("x-product-thumbnail-", "");
      const mainSlider = document.getElementById("x-product-" + sectionId);
      const mediaList = document.getElementById("media_product-" + sectionId);

      if (!mainSlider || !mainSlider.splide || !mediaList) return;

      const realSlides = getRealSlides(mediaList);
      const currentSlide = realSlides[mainSlider.splide.index || 0];

      if (currentSlide && !selectedBySection[sectionId]) {
        selectedBySection[sectionId] = currentSlide.getAttribute("data-media-id");
      }

      if (selectedBySection[sectionId]) {
        setActiveThumbnailByMediaId(thumbnailWrapper, selectedBySection[sectionId]);
      }

      if (!thumbnailWrapper.dataset.customHoverReady) {
        thumbnailWrapper.dataset.customHoverReady = "true";

        thumbnailWrapper.addEventListener("mouseleave", function () {
          const data = getSectionData(thumbnailWrapper.querySelector(".x-thumbnail"));
          if (!data) return;

          const selectedMediaId = selectedBySection[sectionId];
          if (!selectedMediaId) return;

          goToMediaId(data, selectedMediaId);
          setActiveThumbnailByMediaId(thumbnailWrapper, selectedMediaId);
        });
      }
    });
  }

  document.addEventListener("mouseover", function (event) {
    const thumbnail = event.target.closest('[id^="x-product-thumbnail-"] .x-thumbnail');
    if (!thumbnail) return;

    const data = getSectionData(thumbnail);
    if (!data) return;

    const hoverMediaId = getMediaIdFromThumbnail(thumbnail);
    if (!hoverMediaId) return;

    goToMediaId(data, hoverMediaId);

    /* Keep border on clicked/selected thumbnail, not hovered thumbnail */
    const selectedMediaId = selectedBySection[data.sectionId] || getCurrentMediaId(data);
    if (selectedMediaId) {
      setActiveThumbnailByMediaId(data.thumbnailWrapper, selectedMediaId);
    }
  });

  document.addEventListener("click", function (event) {
    const thumbnail = event.target.closest('[id^="x-product-thumbnail-"] .x-thumbnail');
    if (!thumbnail) return;

    const data = getSectionData(thumbnail);
    if (!data) return;

    const clickedMediaId = getMediaIdFromThumbnail(thumbnail);
    if (!clickedMediaId) return;

    selectedBySection[data.sectionId] = clickedMediaId;
    setActiveThumbnailByMediaId(data.thumbnailWrapper, clickedMediaId);

    /* Let Eurus/Splide native click behavior run, then re-confirm border */
    setTimeout(function () {
      selectedBySection[data.sectionId] = clickedMediaId;
      setActiveThumbnailByMediaId(data.thumbnailWrapper, clickedMediaId);
    }, 80);
  });

  function runInit() {
    initSelectedStates();
    setTimeout(initSelectedStates, 500);
    setTimeout(initSelectedStates, 1500);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runInit);
  } else {
    runInit();
  }

  document.addEventListener("shopify:section:load", runInit);
  document.addEventListener("eurus:media-gallery-ready", runInit);
})();




















/* =========================================================
   PDP: force SE Wishlist to initialize as early as possible
========================================================= */
(function () {
  function initSeWishlistEarly() {
    const wishlistEl = document.querySelector(
      ".product-content-container .pdp-wishlist-button .wishlist-engine"
    );

    if (!wishlistEl) return;

    /* Trigger common SE Wishlist init events */
    document.dispatchEvent(new Event("wishlist-engine-init"));
    document.dispatchEvent(new Event("se-wishlist-init"));

    /* Some wishlist apps listen on window instead of document */
    window.dispatchEvent(new Event("wishlist-engine-init"));
    window.dispatchEvent(new Event("se-wishlist-init"));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSeWishlistEarly);
  } else {
    initSeWishlistEarly();
  }

  window.addEventListener("load", initSeWishlistEarly);
  document.addEventListener("shopify:section:load", initSeWishlistEarly);

  /* Extra retry because app scripts can load after DOM ready */
  setTimeout(initSeWishlistEarly, 100);
  setTimeout(initSeWishlistEarly, 300);
  setTimeout(initSeWishlistEarly, 700);
})();


document.addEventListener("DOMContentLoaded", function () {
  const thumbnailColumns = document.querySelectorAll(
    '.product-media-container .splide-image > [id^="x-product-thumbnail-"]'
  );

  thumbnailColumns.forEach(function (column) {
    let scrollTimer;

    column.addEventListener(
      "scroll",
      function () {
        column.classList.add("is-thumbnail-scrolling");

        clearTimeout(scrollTimer);

        scrollTimer = setTimeout(function () {
          column.classList.remove("is-thumbnail-scrolling");
        }, 180);
      },
      { passive: true }
    );
  });
});


